module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('f7-fab', {
    staticClass: "leftfav button-fab button-fab bottomButton floatingButtonToolbarBlank fab-extended floating-button",
    attrs: {
      "href": "/settings/remind/add/"
    }
  }, [_c('i', {
    staticClass: "icon f7-icons"
  }, [_vm._v("add")]), _vm._v(" "), _c('span', {
    staticClass: "showLargeScreenOnly fab-label"
  }, [_vm._v("Add reminder")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('f7-searchbar', {
    staticClass: "search",
    attrs: {
      "cancel-link": "Cancel",
      "placeholder": "Search in Remind Settings",
      "search-list": "remind-setting-list"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutSubtitle"
  }), _vm._v(" "), _c('cm-remind-setting-list', {
    attrs: {
      "remindSettings": _vm.remindSettings
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e1b7b2fe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1b7b2fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/CMRemindSettingPage.vue
// module id = 2453
// module chunks = 2